import { HeaderEditButton, PopupButtonMessage } from 'components';
import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  ButtonsContainer,
  HeaderContainer,
  Headline,
  LogoutButton,
  StyledLogoutIcon,
} from './styled';

const Header = ({ onLogOut, openEditSidebar }) => {
  const { t } = useTranslation();

  return (
    <HeaderContainer>
      <Headline>{t('profile.myProfile')}</Headline>
      <ButtonsContainer>
        <HeaderEditButton
          title={t('profile.editProfile')}
          openEditSidebar={openEditSidebar}
        />
        <PopupButtonMessage
          ButtonComponent={LogoutButton}
          IconComponent={StyledLogoutIcon}
          onConfirm={onLogOut}
          popupButtonText={t('common.logout')}
          popupHeaderText={t('common.logoutHeader')}
          popupMessageText={t('common.logoutMessage')}
          size="lg"
          tooltipText={t('common.logoutTooltip')}
          tooltipStyle={{
            whiteSpace: 'pre-wrap',
            maxWidth: '200px',
            height: 'auto',
          }}
        />
      </ButtonsContainer>
    </HeaderContainer>
  );
};

export default Header;
